<template>
    <div class="CourseManagement">
        <!-- 移动端返回 -->
        <div class="mobileReturn" @click="toReturn">
            <img src="../../assets/img/nav_return.svg" />
            <p>课程管理</p>
        </div>
        <div class="minCont">
            <!-- 人次 -->
            <div class="personNum">
                <div class="Box">
                    <p>平台访问人次</p>
                    <h2>{{loginCount}}</h2>
                </div>
                <div class="Box">
                    <p>学习人次</p>
                    <h2>{{studyNum}}</h2>
                </div>
                <div class="Box">
                    <p>评价人次</p>
                    <h2>{{commentNum}}</h2>
                </div>
            </div>
            <!-- 搜索 -->
            <div class="middleCont">
                <h3>课程统计</h3>
                <!-- 移动端搜索 -->
                <div class="mobileSearch">
                    <input type="text" v-model="courseName" placeholder="课程名称" @keyup.enter="queryName">
                </div>
                <div class="searchBox">
                    <div class="inputBox">
                        <el-input v-model="courseName" placeholder="课程名称"></el-input>
                    </div>
                    <span @click="queryName">查询</span>
                </div>
            </div>
            <!-- 移动端列表头 -->
            <div class="mobileListTitle">
                <p>课程名称 | 上线时间 | 评价人次</p>
                <p>学习人次</p>
            </div>
            <!-- 列表头 -->
            <ul class="listTitleWrap">
                <li>
                    <span class="name">课程名称</span>
                    <span class="sxTime">上线时间</span>
                    <span class="studyNum">学习人次</span>
                    <span class="pjNum">评价人次</span>
                </li>
            </ul>
            <!-- 列表内容 -->
            <ul class="listContWrap">
                <li v-for="(item,index) in courseList" :key="index" @click="openEvaluate(item.ID,item.Title)">
                    <div class="name-time-pj">
                        <span class="name">{{item.Title}}</span>
                        <div class="time-pj">
                            <span class="sxTime">{{item.PubDate | formatData}}</span>
                            <span class="pj">{{item.CommentNum+'次评价'}}</span>
                        </div>
                    </div>
                    <span class="studyNum">{{item.ClassNum}}</span>
                    <span class="pjNum">{{item.CommentNum}}</span>
                </li>
            </ul>
            <!-- 分页器 -->
            <div class="page"><Pagination :total='totalPage' :page="page" :pageSize = 'pagesize' @currentPage="currentPage"></Pagination></div>
            <!-- 移动端查看更多 -->
            <p class="moreCourse" v-if="isShowMore" @click="getMore">查看更多</p>
        </div>
        <!-- 评价内容查看页 -->
        <div class="personInfoCover" v-if="isShowEvaluate" @click.self="closeEvaluate">
            <div class="personInfoWrap">
                <!-- 搜素 -->
                <div class="otherWrap">
                    <h3>{{courseTitle}}</h3>
                    <p>{{'共计'+commentTotal+'人参与评价'}}</p>
                </div>
                <!-- 列表标题 -->
                <ul class="evaluateListTitle">
                    <li>
                        <span>评价内容</span>
                        <span>不太满意</span>
                        <span>基本满意</span>
                        <span>较满意</span>
                        <span>很满意</span>
                    </li>
                </ul>
                <!-- 列表 -->
                <ul class="evaluateList">
                    <li v-for="(item,index) in evaluateList" :key="index">
                        <span>{{item.Name}}</span>
                        <div class="evaluateNum">
                            <span v-for="(it,ind) in item.Items" :key="ind">{{it.Rate+"%"}}</span>
                        </div>
                    </li>
                </ul>
                <!-- 课程评价内容 -->
                <div class="evaluateContWrap">
                    <h2>课程评价内容</h2>
                    <p class="noEvaluate" v-if="isShowEvaluateCont">暂无评论</p>
					<div v-else>
						<ul class="evaluateBox" v-infinite-scroll="loadList" :infinite-scroll-disabled="disabled">
							<li v-for="(item,index) in evaluateContList" :key="index">
								<h5>评价内容</h5>
								<p>{{item.Memo}}</p>
								<span>{{item.CreateDate}}</span>
							</li>
						</ul>
					</div>
                </div>
                <!-- 关闭 -->
                <div class="close" @click="closeEvaluate"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import '../../assets/js/formatTime'
export default {
    data() {
        return {
            totalPage:0,  // 总页数
            page:1,  // 页数
            pagesize:9,  // 多少条数据
            courseName:'',  // input值
            loginCount:0,  // 平台访问人次
            studyNum:0,  // 学习人次
            commentNum:0,  // 评论人次
            courseList:[],  // 课程列表
            evaluateList:[],  // 评价百分比列表
            commentTotal:0,  // 参与评论人数
            courseTitle:'',  // 详情标题
            isShowEvaluateCont:true,  // 是否显示评价内容
            isShowEvaluate:false,  // 是否显示课程评价信息
            evaluateContList:[],  // 评价内容列表
			evaluatePage:0,  // 评价内容页码
            isPage:false,  // 判断是否是查询了课程名称，来决定传参
            isShowMore:true,  // 是否显示查看更多
			evaluateCourseId:0  // 获取课程评价内容id
        }
    },
    mounted(){
        // 获取课程列表
        this.getCourseList();
        // 查看平台的数据统计
        this.getDataStatistics();
    },
    methods: {
        // 查看平台的数据统计
        getDataStatistics(){
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp
            }
            this.$axios.post(Const_Api_Root+'api/AdminCenter/Show',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.loginCount = res.data.Data.LoginCount;
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 获取课程列表
        getCourseList(type){
            // 获取课程列表
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "StrParm": this.courseName, 
                "PageSize":this.pagesize,
                "CurPage":this.page
            }
            this.$axios.post(Const_Api_Root+'api/AdminCenter/CourseSum',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.totalPage = res.data.Data.Total;

                    if(type == 'more'){
                        // 移动端的操作
                        this.courseList = this.courseList.concat(res.data.Data.Rows);
                    }else{
                        // 列表
                        this.courseList = res.data.Data.Rows;
                    }

                    // 是否显示查看更多
                    if(this.totalPage != this.courseList.length){
                        this.isShowMore = true;
                    }else{
                        this.isShowMore = false;
                    }
                    
                    if(this.isPage) return;
                    this.studyNum = res.data.Data.ClassNum;
                    this.commentNum = res.data.Data.CommentNum;
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 查询
        queryName(){
            if(this.courseName == '') return;
            this.page = 1;
            this.getCourseList();
            this.isPage = true;
        },
        // 分页器
        currentPage(index){
            this.page = index;
            if(!this.page){
                this.courseName = '';
            }
            this.getCourseList();
        },
        // 移动端的获取更多
        getMore(){
            this.page++;
            if(!this.page){
                this.courseName = '';
            }
            this.getCourseList('more');
        },
        // 打开评价内容
        openEvaluate(courseId,title){
            this.isShowEvaluate = true;
            this.courseTitle = title;
			this.evaluateCourseId = courseId;
            // 获取课程列表
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":courseId
            }
            // 获取课程评价评分
            this.getCommentScore(data);
			// 获取课程评价内容
			this.getCommentList();
        },
        // 获取课程评分统计
        getCommentScore(data){
            this.$axios.post(Const_Api_Root+'api/Course/CommentScore',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.evaluateList = res.data.Data;
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
		// 获取课程评论内容
		loadList(){
		    setTimeout(() => {
		        this.evaluatePage++;
		        // 获取课程评价内容
		        this.getCommentList();
		    }, 1000);
		},
        // 获取课程评论内容
        getCommentList(){
			let timestamp = Date.parse(new Date())/1000;
			let data = {
			    "TimeStamp":timestamp,
			    "ID":this.evaluateCourseId,
				"PageSize":this.pagesize,
				"CurPage":this.evaluatePage
			}
            this.$axios.post(Const_Api_Root+'api/Course/CommentList',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.commentTotal = res.data.Data.Total;
                    if(this.commentTotal != 0){
                        this.isShowEvaluateCont = false;
                    }else{
                        this.isShowEvaluateCont = true;
                    }
                    this.evaluateContList = res.data.Data.Rows;
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 关闭
        closeEvaluate(){
            this.isShowEvaluate = false;
        },
        // 移动端返回
        toReturn(){
            this.$router.push({path: '/index'});
        }
    },
	computed: {
	    noMore () {
			return this.evaluateContList.length >= this.commentTotal;
	    },
	    disabled () {
	        return this.noMore
	    }
	},
    filters: {
        // 格式化时间
        formatData:(value) => {
            value = new Date(value).Format("yyyy-MM-dd");
            return value;
        }
    },
    components: {
        Pagination
    }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px){
    .CourseManagement{
        width: 100%;
        padding: 0 17px;
        .page{
            display: none;
        }
    }
    // 查看更多
    .moreCourse{
        font-size: 14px;
        color: #0061FE;
        text-align: center;
        font-weight: bold;
        padding: 20px 0;
    }
    // 返回
    .mobileReturn{
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;

        position: relative;
        p{
            font-size: 14px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
        img{
            width: 30px;
            height: 30px;
        }
    }
    // 人次总数
    .personNum{
        display: flex;
        .Box{
            flex: 1;

            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #FAFAFA;
            height: 80px;
            margin-right: 1px;
            font-size: 0;
            p{
                font-size: 12px;
                color: rgba(25,25,26,0.80);
            }
            h2{
                font-size: 16px;
                margin-top: 5px;
            }
        }
    }
    // 搜索
    .middleCont{
        .searchBox{
            display: none;
        }
        h3{
            font-size: 16px;
            margin: 20px 0 0;
        }
        .mobileSearch{
            width: 100%;
            margin: 10px 0 30px;
            input{
                width: 100%;
                background: #FAFAFA;
                border-radius: 10px;
                height: 40px;
                text-indent: 20px;
            }
        }
    }
    // 列表头
    .mobileListTitle{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        p{
            font-size: 12px;
            color: rgba(25,25,26,0.80);
        }
    }
    .listTitleWrap{
        display: none;
    }
    // 列表
    .listContWrap{
        width: 100%;
        li{
            padding: 15px 0;
            border-bottom: 2px solid #fafafa;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .pjNum{
                display: none;
            }
            .studyNum{
                font-size: 18px;
            }
            .name{
                font-size: 14px;
            }
            .time-pj{
                margin-top: 6px;
                font-size: 12px;
                color: rgba(25,25,26,0.80);
            }
            .pj{
                margin-left: 14px;
            }
        }
    }
    // 课程统计
    .personInfoCover{
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.40);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 17px;
    
        position: fixed;
        top: 0;
        left: 0;
        .personInfoWrap{
            width: 100%;
            padding: 0 10px 10px;
            box-sizing: border-box;
            background-color: #fff;
            border-radius: 16px;
    
            position: relative;
            .otherWrap{
                text-align: center;
                margin-bottom: 15px;
                h3{
                    font-size: 14px;
                    padding: 21px 0 15px;
                }
                p{
                    font-size: 10px;
                    color: #0061FE;
                }
            }
        }
        .close{
            width: 24px;
            height: 24px;
            background: url('../../assets/img/delete_icon.svg') no-repeat center;
            background-size: 100%;
            cursor: pointer;
    
            position: absolute;
            top: 17px;
            right: 17px;
        }
    }
    .evaluateListTitle li{
        display: flex;
        align-items: center;
        cursor: pointer;
        span{
            font-size: 10px;
            color: rgba(25,25,26,0.80);
            width: 13%;
            display: block;
            text-align: center;
            &:first-child{
                display: none;
            }
            &:nth-child(2){
                width: 56%;
                text-align: right;
            }
            &:nth-child(3){
                width: 18%;
            }
        }
    }
    .evaluateList{
        li{
            display: flex;
            align-items: center;
            background: #FAFAFA;
            height: 62px;
            border-bottom: 1px solid #fff;
            span{
                display: block;
                border-right: 1px solid #fff;
                margin-left: 10px;
            }
        }
        li>span{
            font-size: 14px;
            width: 40%;
        }
        .evaluateNum{
            width: 60%;
            display: flex;
            span{
                font-size: 12px;
                width: 25%;
            }
        }
    }
    // 评价内容
    .evaluateContWrap{
        .noEvaluate{
            font-size: 14px;
            line-height: 40px;
            letter-spacing: 0.5px;
            color: rgba(25,25,26,0.80);
        }
        h2{
            font-size: 16px;
            margin: 20px 0 0;
        }
        .evaluateBox{
            overflow: hidden;
            overflow-y: scroll;
            height: 200px;
            h5{
                font-size: 14px;
                margin-top: 20px;
            }
            p{
                font-size: 14px;
                color: rgba(25,25,26,0.80);
                letter-spacing: 0.5px;
                line-height: 28px;
            }
            span{
                font-size: 12px;
                color: rgba(25,25,26,0.80);
            }
        }
    }
}
@media screen and (min-width: 1445px) {
    .CourseManagement{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        // 移动端返回+输入框+查看更多
        .mobileReturn,.mobileSearch,.moreCourse{
            display: none;
        }
        .minCont{
            width: 1200px;
            margin: 40px auto;
        }
        .personNum{
            display: flex;
            .Box{
                background: #FAFAFA;
                width: 399px;
                height: 144px;
                margin-right: 1px;
                font-size: 0;
                padding: 30px;
                p{
                    font-size: 16px;
                    color: rgba(25,25,26,0.80);
                }
                h2{
                    font-size: 40px;
                    margin-top: 20px;
                }
            }
        }
        .page{
            margin-top: 40px;
        }
    }
    .middleCont{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 30px 0 40px;
        h3{
            font-size: 24px;
        }
        .searchBox{
            display: flex;
            align-items: center;
            .inputBox{
                width: 240px;
            }
            span{
                color: #0061FE;
                font-size: 14px;
                cursor: pointer;
                margin-left: 40px;
            }
        }
    }
    // 移动端列表头
    .mobileListTitle{
        display: none;
    }
    ul{
        width: 100%;
    }
    // 表头
    .listTitleWrap{
        margin-bottom: 8px;
        li{
            font-size: 12px;
            display: flex;
            align-items: center;
            border-bottom: 2px solid #fafafa;
            padding-bottom: 20px;
            span{
                font-size: 14px;
                width: 10%;
                display: block;
                &:last-child{
                    text-align: right;
                }
            }
            .sxTime{
                width: 15%;
            }
            .name{
                width: 65%;
                overflow: hidden; 
                text-overflow: ellipsis;
                white-space: nowrap; 
            }
        }
    }
    // 列表内容
    .listContWrap{
        min-height: 513px;
        li{
            display: flex;
            align-items: center;
            cursor: pointer;
            padding: 18px 0;
            border-bottom: 2px solid #fafafa;
            span{
                font-size: 14px;
                color: rgba(25,25,26,0.80);
            }
            .name-time-pj{
                width: 80%;
                display: flex;
                .name{
                    width: 81%;
                }
                .time-pj{
                    width: 19%;
                }
                .pj{
                    display: none;
                }
            }
            .studyNum,.pjNum{
                width: 10%;
            }
            .pjNum{
                text-align: right;
                padding-right: 10px;
            }
        }
    }
    // 评价内容
    .personInfoCover{
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.40);
        display: flex;
        align-items: center;
        justify-content: center;
    
        position: fixed;
        top: 0;
        left: 0;
        .personInfoWrap{
            width: 1015px;
            padding: 0 63px 0 60px;
            box-sizing: border-box;
            background-color: #fff;
            border-radius: 16px;
    
            position: relative;
            .otherWrap{
                text-align: center;
                margin-bottom: 30px;
                h3{
                    font-size: 24px;
                    margin: 30px 0 13px;
                }
                p{
                    font-size: 14px;
                    color: #0061FE;
                }
            }
            .evaluateListTitle li,.evaluateList li{
                display: flex;
                align-items: center;
                cursor: pointer;
                span{
                    width: 15%;
                    display: block;
                    padding-left: 19px;
                    &:first-child{
                        width: 40%;
                    }
                }
            }
            .evaluateListTitle{
                font-size: 12px;
                color: rgba(25,25,26,0.80);
            }
            .evaluateList{
                background: #FAFAFA;
                border-radius: 16px;
                margin: 10px 0 20px;
                li{
                    border-bottom: 1px solid #fff;
                    line-height: 50px;
                    span{
                        border-right: 1px solid #fff;
                    }
                    .evaluateNum{
                        display: flex;
                        width: 60%;
                        span{
                            width: 25%;
                            font-size: 16px;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
        .close{
            width: 24px;
            height: 24px;
            background: url('../../assets/img/delete_icon.svg') no-repeat center;
            background-size: 100%;
            cursor: pointer;
    
            position: absolute;
            top: 30px;
            right: 30px;
        }
    }
    // 课程评价
    .evaluateContWrap{
        .noEvaluate{
            font-size: 14px;
            height: 250px;
            letter-spacing: 0.5px;
            color: rgba(25,25,26,0.80);
        }
        h2{
            font-size: 24px;
            margin-bottom: 10px;
        }
        ul{
            padding: 0 130px;
            font-size: 14px;
            overflow: hidden;
            overflow-y: scroll;
            height: 400px;
            margin-bottom: 10px;
            h5{
                margin: 15px 0 10px;
            }
            p{
                color: rgba(25,25,26,0.80);
                width: 100%;
                letter-spacing: 0.5px;
                line-height: 28px;
            }
            span{
                font-size: 12px;
                color: rgba(25,25,26,0.80);
                margin: 9px 0 17px;
                display: block;
            }
        }
    }
}
@media screen and (min-width: 1029px) and (max-width: 1440px){
    .CourseManagement{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        // 移动端返回+查看更多
        .mobileReturn,.moreCourse{
            display: none;
        }
        .minCont{
            width: 1100px;
            margin: 40px auto;
        }
        .personNum{
            display: flex;
            .Box{
                background: #FAFAFA;
                width: 366px;
                height: 144px;
                margin-right: 1px;
                font-size: 0;
                padding: 30px;
                p{
                    font-size: 16px;
                    color: rgba(25,25,26,0.80);
                }
                h2{
                    font-size: 40px;
                    margin-top: 20px;
                }
            }
        }
        .page{
            margin-top: 40px;
        }
    }
    .middleCont{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 30px 0 40px;
        .mobileSearch{
            display: none;
        }
        h3{
            font-size: 24px;
        }
        .searchBox{
            display: flex;
            align-items: center;
            .inputBox{
                width: 240px;
            }
            span{
                color: #0061FE;
                font-size: 14px;
                cursor: pointer;
                margin-left: 40px;
            }
        }
    }
    
    ul{
        width: 100%;
    }
    // 移动端列表头
    .mobileListTitle{
        display: none;
    }
    // 表头
    .listTitleWrap{
        margin-bottom: 8px;
        li{
            font-size: 12px;
            display: flex;
            align-items: center;
            border-bottom: 2px solid #fafafa;
            padding-bottom: 20px;
            span{
                font-size: 14px;
                width: 10%;
                display: block;
                &:last-child{
                    text-align: right;
                }
            }
            .sxTime{
                width: 15%;
            }
            .name{
                width: 65%;
                overflow: hidden; 
                text-overflow: ellipsis;
                white-space: nowrap; 
            }
        }
    }
    // 列表内容
    .listContWrap{
        min-height: 513px;
        li{
            display: flex;
            align-items: center;
            cursor: pointer;
            padding: 18px 0;
            border-bottom: 2px solid #fafafa;
            span{
                font-size: 14px;
                color: rgba(25,25,26,0.80);
            }
            .name-time-pj{
                width: 80%;
                display: flex;
                .name{
                    width: 81%;
                }
                .time-pj{
                    width: 19%;
                }
                .pj{
                    display: none;
                }
            }
            .studyNum,.pjNum{
                width: 10%;
            }
            .pjNum{
                text-align: right;
                padding-right: 10px;
            }
        }
    }
    // 评价内容
    .personInfoCover{
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.80);
        display: flex;
        align-items: center;
        justify-content: center;
    
        position: fixed;
        top: 0;
        left: 0;
        .personInfoWrap{
            width: 70%;
            height: 100%;
            transform: scale(.9);
            padding: 0 40px;
            box-sizing: border-box;
            background-color: #fff;
            border-radius: 16px;
    
            position: relative;
            .otherWrap{
                text-align: center;
                margin-bottom: 15px;
                h3{
                    font-size: 18px;
                    margin: 20px 0 10px;
                }
                p{
                    font-size: 13px;
                    color: #0061FE;
                }
            }
            .evaluateListTitle li,.evaluateList li{
                display: flex;
                align-items: center;
                cursor: pointer;
                span{
                    width: 15%;
                    display: block;
                    padding-left: 19px;
                    &:first-child{
                        width: 40%;
                    }
                }
            }
            .evaluateListTitle{
                font-size: 12px;
                color: rgba(25,25,26,0.80);
            }
            .evaluateList{
                background: #FAFAFA;
                border-radius: 16px;
                margin: 10px 0 20px;
                li{
                    line-height: 35px;
                    border-bottom: 1px solid #fff;
                    span{
                        border-right: 1px solid #fff;
                    }
                    .evaluateNum{
                        display: flex;
                        width: 60%;
                        span{
                            width: 25%;
                            font-size: 13px;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
        .close{
            width: 20px;
            height: 20px;
            background: url('../../assets/img/delete_icon.svg') no-repeat center;
            background-size: 100%;
            cursor: pointer;
    
            position: absolute;
            top: 20px;
            right: 25px;
        }
    }
    // 课程评价
    .evaluateContWrap{
        .noEvaluate{
            font-size: 14px;
            height: 250px;
            letter-spacing: 0.5px;
            text-indent: 131px;
            color: rgba(25,25,26,0.80);
        }
        h2{
            font-size: 18px;
            margin-bottom: 10px;
        }
        ul{
            padding: 0 100px;
            font-size: 14px;
            overflow: hidden;
            overflow-y: scroll;
            height: 250px;
            h5{
                margin: 10px 0 5px;
            }
            p{
                color: rgba(25,25,26,0.80);
                width: 100%;
                letter-spacing: 0.5px;
                line-height: 28px;
            }
            span{
                font-size: 12px;
                color: rgba(25,25,26,0.80);
                margin: 5px 0 0;
                display: block;
            }
        }
    }
}
// 公用
.personNum{
    .Box:first-child{
        border-radius: 16px 0 0 16px;
    }
    .Box:last-child{
        border-radius: 0 16px 16px 0;
    }
}
// 修改placeholder样式
input::-webkit-input-placeholder{
    font-size: 12px;
    color: rgba(25,25,26,0.20);
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    font-size: 12px;
    color: rgba(25,25,26,0.20);
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    font-size: 12px;
    color: rgba(25,25,26,0.20);
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    font-size: 12px;
    color: rgba(25,25,26,0.20);
}
// 滚动条
/*正常情况下滑块的宽高*/
.evaluateBox::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}
/*正常情况下滑块的样式*/
.evaluateBox::-webkit-scrollbar-thumb {
    background-color: #C8CCD6;
    border-radius: 10px;
    -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
}
/*鼠标悬浮在该类指向的控件上时滑块的样式*/
.evaluateBox:hover::-webkit-scrollbar-thumb {
    background-color:  #C8CCD6;
    border-radius: 10px;
    -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
}
/*鼠标悬浮在滑块上时滑块的样式*/
.evaluateBox::-webkit-scrollbar-thumb:hover {
    background-color:  #C8CCD6;
    -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
}
/*正常时候的主干部分*/
.evaluateBox::-webkit-scrollbar-track {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px #EFEFEF;;
    background-color: transparent;
}
/*鼠标悬浮在滚动条上的主干部分*/
.evaluateBox::-webkit-scrollbar-track:hover {
    -webkit-box-shadow: inset 0 0 6px #EFEFEF;
    background-color: rgba(0,0,0,.01);
}
</style>



// WEBPACK FOOTER //
// src/pages/ManagementCenter/CourseManagement.vue